export default "__VITE_ASSET__DnD65whA__"